import React, { useState, useEffect, useRef } from "react";
import {
  TableContainer,
  Paper,
  Typography,
  Box,
  PaginationItem,
} from "@mui/material";
import { api, get } from "../../../../utils/api";
import { styled } from "@mui/material/styles";
import DateRangePickerComponent from "../../Roles and Permissions/Filters/Date";
import PaginationBox from "../../../../Components/Masters/Pagination";
import DeleteDialog from "../../../../Components/Masters/DeleteDialog";
import ColumnHeadings from "../../../../Components/Masters/ColumnHeadings";
import MenuActions from "../../../../Components/Masters/MenuActions";
import TableContent from "../../../../Components/Masters/TableContent";
import FilterDrawer from "../../../../Components/Masters/FilterDrawer";
import TopMenu from "../../../../Components/Masters/TopMenu";
import MessagePopup from "../../../../Components/Masters/MessagePopup";
import TableHeading from "../../../../Components/Masters/TableHeading";
import MenuIcon from "../../../../Components/Masters/MenuIcon";
import MultiSelect from "../../Roles and Permissions/Filters/MultiSelect";
import AddPurchasedGoods from "./AddPurchasedGoods";
import ViewPurchasedGoods from "./ViewPurchasedGoods";
import NoDataFound from "../../../../Components/Masters/NoDataFound";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import MastersSidebar from "../../../../Layout/MastersSidebar";
import Unauthorized from "../../../../Components/Unauthorized/Unauthorized";

const PurchasedGoods = () => {
  const [data, setData] = useState([]);
  const [sortConfig, setSortConfig] = useState({
    key: "createdAt",
    direction: "desc",
  });
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedData, setSelectedData] = useState(null);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [addData, setAddData] = useState(false);
  const [appliedFilters, setAppliedFilters] = useState({
    Date: false,
    Country: false,
  });
  const [viewData, setViewData] = useState(false);
  const [element, setElement] = useState(null);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [limit] = useState(10); // Number of items per page
  const [selectedFilter, setSelectedFilter] = useState("Date");
  const [drawerFilterOpen, setDrawerFilterOpen] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [uniqueValues, setUniqueValues] = useState({});
  const [errors, setErrors] = useState({
    Date: false,
    Country: false,
  });
  const [isFiltersApplied, setIsFiltersApplied] = useState(false);
  const [selectedFields, setSelectedFields] = useState({
    country: [],
  });
  const [tempFilter, setTempFilter] = useState({
    country: [],
    startDate: null,
    endDate: null,
  });

  const filters = ["Date", "Country"];

  const inputData = [
    {
      fieldName: "vendorLegalName",
      title: "Vendor Legal Name",
      placeholder: "Enter Legal Name",
      //   url: `${api}/vendor/getAll`, // Assuming there's an API to get all vendors
    },
    {
      fieldName: "country",
      title: "Country",
      placeholder: "Tap to Select",
      type: "select",
    },
    {
      fieldName: "goodsAndServicesName",
      title: "Name of Goods and Services",
      placeholder: "Enter Name",
    },
    {
      fieldName: "gstNumber",
      title: "GST Number",
      placeholder: "Enter 15 digit GST Number",
    },
    {
      fieldName: "address",
      title: "Address",
      placeholder: "Enter Address",
    },
    {
      fieldName: "personInChargeName",
      title: "Name of Person in Charge",
      placeholder: "Enter Incharge Name",
    },
    {
      fieldName: "contactNumber",
      title: "Contact Number",
      placeholder: "Enter Mobile No ",
    },
    {
      fieldName: "email",
      title: "Email ID",
      placeholder: "Enter Email",
    },
  ];

  const fetchUniqueValues = async () => {
    try {
      const response = await get(`/master/purchasedGoods`);
      const data = response.data.data;
      const uniqueCountries = [
        ...new Set(
          data.map((el) => el.country).filter(Boolean) // Filter out undefined values
        ),
      ];
      return {
        country: uniqueCountries,
      };
    } catch (error) {
      return {};
    }
  };

  const updatePage = () => {
    if (page > 1 && data.length === 1) {
      setPage(page - 1);
    }
    fetchData();
  };

  // fetching Vehicle data
  const fetchData = async (
    filters = isFiltersApplied ? filtersToApply : {}
  ) => {
    try {
      const queryParams = new URLSearchParams({
        ...filters,
        page, // Add the current page
        limit: rowsPerPage, // Add the number of rows per page
        sortField: sortConfig.key, // Sort configuration
        sortOrder: sortConfig.direction,
      }).toString();
      const response = await get(`/master/purchasedGoods?${queryParams}`);
      setData(response.data.data); // Update the user list
      setTotalPages(response.data.totalPages); // Update total pages for pagination
      const uniqueValues = await fetchUniqueValues();
      setUniqueValues(uniqueValues);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [page, rowsPerPage, sortConfig]);

  const handleMenuClick = (event, element) => {
    setAnchorEl(event.currentTarget);
    setSelectedData(element);
    setElement(element);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedData(null);
  };

  const handleEdit = () => {
    handleMenuClose();
    setAddData(true);
    setViewData(false);
  };

  const handleView = () => {
    handleMenuClose();
    setViewData(true);
    setAddData(false);
  };

  const handleDelete = () => {
    handleMenuClose();
    setDeleteDialog(true);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const filtersToApply = {
    startDate: tempFilter?.startDate
      ? tempFilter?.startDate.format("YYYY-MM-DD")
      : "",
    endDate: tempFilter?.endDate
      ? tempFilter?.endDate.format("YYYY-MM-DD")
      : "",
    country: tempFilter?.country.join(",") || [],
  };

  // Applying selected filters
  const handleApplyFilters = () => {
    setPage(1);
    fetchData(filtersToApply);
    setStartDate(tempFilter?.startDate);
    setEndDate(tempFilter?.endDate);
    setSelectedFields({
      country: tempFilter?.country || [],
    });
    setIsFiltersApplied(true);
    handleAppliedFilters();
    setDrawerFilterOpen(false);
  };

  const handleResetFilters = async () => {
    // Reset local state for date selection and selected fields
    setTempFilter({
      startDate: null,
      endDate: null,
      country: [],
    });
    setStartDate(null);
    setEndDate(null);
    setSelectedFields({
      country: [],
    });
    setPage(1);
    // Call fetchData without any filters
    await fetchData({});
    setErrors({});
    setAppliedFilters({});
    setIsFiltersApplied(false);
    setDrawerFilterOpen(false);
  };

  const handleAppliedFilters = () => {
    const isDateApplied =
      tempFilter?.startDate || tempFilter?.endDate ? true : false;
    const isCountryApplied = tempFilter?.country?.length > 0 ? true : false;

    setIsFiltersApplied(isDateApplied || isCountryApplied);

    setAppliedFilters((prevAppliedFilters) => ({
      ...prevAppliedFilters,
      Date: isDateApplied,
      Country: isCountryApplied,
    }));
  };

  // Handle Sorting function
  const handleSort = (column, direction) => {
    setSortConfig({ key: column, direction });
  };

  const StyledPaginationItem = styled(PaginationItem)(({ theme }) => ({
    "&.Mui-selected": {
      backgroundColor: "green",
      color: "#fff",
      fontWeight: "bold",
    },
    "&:hover": {
      backgroundColor: "#ededed",
    },
  }));

  const handleFilterDrawer = () => {
    setTempFilter({
      startDate: startDate,
      endDate: endDate,
      country: selectedFields.country,
    });
    setDrawerFilterOpen(false);
  };

  const columnHeadings = [
    {
      fieldName: "createdAt",
      title: "Date",
    },
    {
      fieldName: "vendorLegalName",
      title: "Vendor Legal Name",
    },
    {
      fieldName: "country",
      title: "Country",
    },
    {
      fieldName: "gstNumber",
      title: "GST Number",
    },
    {
      fieldName: "goodsAndServicesName",
      title: "Name of Goods and Services",
    },
  ];

  // Function to render the selected filter component based on user's choice
  const renderSelectedFilter = () => {
    switch (selectedFilter) {
      case "Date":
        return (
          <DateRangePickerComponent
            startDate={tempFilter?.startDate}
            endDate={tempFilter?.endDate}
            setStartDate={(date) =>
              setTempFilter((prev) => ({ ...prev, startDate: date }))
            }
            setEndDate={(date) =>
              setTempFilter((prev) => ({ ...prev, endDate: date }))
            }
            setErrors={setErrors}
            errors={errors.Date}
          />
        );
      case "Country":
        return (
          <MultiSelect
            title="Country"
            selectedFields={tempFilter}
            setSelectedFields={(updater) => {
              setTempFilter((prev) => {
                const newValue =
                  typeof updater === "function" ? updater(prev) : updater;
                return {
                  ...prev,
                  country: newValue.country || newValue,
                };
              });
            }}
            errors={errors.Country}
            setErrors={setErrors}
            field="country"
            data={uniqueValues?.country}
          />
        );
      default:
        return null;
    }
  };

  const tableContainerRef = useRef(null); // Reference to the table container
  const [isShortContent, setIsShortContent] = useState(false);

  useEffect(() => {
    const container = tableContainerRef.current;
    if (container) {
      const tableHeight = container.scrollHeight;
      const screenHeight = window.innerHeight;
      setIsShortContent(tableHeight < screenHeight / 1.5);
    }
  }, [data]);

  return (
    <MainDashboardLayout sidebar={<MastersSidebar />}>
      <Unauthorized requiredModule="Purchased goods & services">
        <Box
          sx={{
            backgroundColor: "#ededed",
            width: "100%",
            // height: "100vh",
            // overflowY: "scroll",
            // overflowX: "hidden",
          }}
        >
          <MessagePopup {...{ snackOpen, setsnackOpen }} />{" "}
          {/*Message popup for success or failure */}
          {/* View log, Edit, delete menus */}
          <AddPurchasedGoods
            id={element ? element._id : ""}
            addData={addData}
            setAddData={setAddData}
            data={data}
            element={element}
            addUrl={`${api}/master/purchasedGoods`}
            updateUrl={`${api}/master/purchasedGoods`}
            // details={vehicle}
            fetchData={fetchData}
            setsnackOpen={setsnackOpen}
            inputData={inputData}
          />
          <ViewPurchasedGoods
            id={element ? element._id : ""}
            data={element}
            viewData={viewData}
            setViewData={setViewData}
            inputData={inputData}
            handleEdit={handleEdit}
          />
          {/* {deleteDialog && (
          <DeleteDialog
            {...{ deleteDialog, setDeleteDialog, handleDeleteAggree }}
          />
        )} */}
          {deleteDialog && (
            <DeleteDialog
              fetchData={updatePage}
              {...{
                deleteDialog,
                setDeleteDialog,
                id: element._id,
                url: `${api}/master/purchasedGoods`,
                method: "delete",
                setsnackOpen,
              }}
            />
          )}
          {/* Filter Drawer */}
          {drawerFilterOpen && (
            <FilterDrawer
              {...{
                renderSelectedFilter,
                drawerFilterOpen,
                setDrawerFilterOpen,
                handleApplyFilters,
                handleFilterDrawer,
                setSelectedFilter,
                handleResetFilters,
                selectedFilter,
                filters,
                appliedFilters,
                selectedFields,
                setSelectedFields,
              }}
            />
          )}{" "}
          {/* Top Box for Heading, Filter Button, Add Data Button */}
          <TopMenu
            setData={setElement}
            setAddData={setAddData}
            {...{
              heading: "Scope 3",
              setDrawerFilterOpen,
              filterApplied: isFiltersApplied,
            }}
          />
          <TableContainer
            component={Paper}
            ref={tableContainerRef}
            sx={{ maxWidth: "100%" }}
          >
            <Box>
              <TableHeading heading={"Purchased Goods and Services Vendor"} />
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: "12% 17% 17% 20% 25% 8%",
                  borderBottom: "1px solid #ddd",
                  borderTop: "1px solid #ddd",
                }}
              >
                {columnHeadings.map((el) => (
                  <ColumnHeadings
                    key={el}
                    {...{
                      title: el.title,
                      key: el.title,
                      handleSort,
                      field: el.fieldName,
                      sortConfig,
                    }}
                  />
                ))}
                <Typography
                  sx={{
                    fontWeight: "bold",
                    padding: "8px 12px",
                    textAlign: "center",
                  }}
                >
                  Action
                </Typography>
              </Box>
              {data.length === 0 ? (
                <NoDataFound />
              ) : (
                data.map((item) => (
                  <Box
                    key={item._id}
                    sx={{
                      display: "grid",
                      gridTemplateColumns: "12% 17% 17% 20% 25% 8%",
                      borderBottom: "1px solid #ddd",
                    }}
                  >
                    {columnHeadings.map((el) => (
                      <TableContent
                        key={el.field}
                        {...{
                          fieldData:
                            typeof item[el.fieldName] === "object" &&
                              item[el.fieldName] !== null
                              ? item[el.fieldName]
                              : item[el.fieldName],
                          dateField: el.fieldName === "createdAt" ? item.createdAt : false,
                        }}
                      />
                    ))}
                    {/* Menu Action Icon */}
                    <MenuIcon {...{ handleMenuClick, field: item }} />
                  </Box>
                ))
              )}
            </Box>
          </TableContainer>
          {/* Pagination */}
          {totalPages > 1 && (
            <PaginationBox
              isShortContent={isShortContent} // Pass this state to PaginationBox
              {...{ totalPages, page, handleChangePage, StyledPaginationItem }}
            />
          )}
          <MenuActions
            {...{
              id: element?._id,
              handleView,
              handleEdit,
              handleDelete,
              anchorEl,
              handleMenuClose,
            }}
          />
          {/*Add,Edit,Delete Icons & function calls */}
        </Box>
      </Unauthorized>
    </MainDashboardLayout>
  );
};

export default PurchasedGoods;
